import { OjWebElement } from '@oracle/oraclejet-webdriver/elements';

/**
 * This is the base class for oj-c-message-banner WebElement, and is generated from the
 * component's metadata. Do not modify these contents since they'll be replaced
 * during the next generation.
 * Put overrides into the WebElements's subclass, MessageBannerWebElement.ts.
 */
export class MessageBannerWebElementBase extends OjWebElement {
  /**
   * Gets the value of <code>type</code> property.
   * The type of the Banner message.
   * @return The value of <code>type</code> property.
   *
   */
  public getType(): Promise<string> {
    return this.getProperty<string>('type');
  }

  /**
   * Gets the value of <code>detailTemplateValue</code> property.
   * The function that determines the detail template for the current row.
   * @return The value of <code>detailTemplateValue</code> property.
   *
   */
  public getDetailTemplateValue(): Promise<string | null> {
    return this.getProperty<string | null>('detailTemplateValue');
  }

  /**
   * Gets the value of <code>sorting</code> property.
   * Specifies how to sort the messages from the dataprovider.
   * @return The value of <code>sorting</code> property.
   *
   */
  public getSorting(): Promise<string> {
    return this.getProperty<string>('sorting');
  }
}
